import { useEffect, useState } from 'react'
import styles from './ModalCourse.module.scss'

export default function ModalCourse({ course, onClose }) {
	const [closing, setClosing] = useState(false)

	useEffect(() => {
		document.body.style.overflow = 'hidden'
		return () => {
			document.body.style.overflow = 'auto'
		}
	}, [])

	if (!course) return null

	const handleClose = () => {
		setClosing(true)
		setTimeout(() => onClose(), 300)
	}

	const handleRegister = () => {
		setClosing(true)
		setTimeout(() => {
			onClose()
			const formSection = document.getElementById('form-section')
			if (formSection) {
				const rect = formSection.getBoundingClientRect()
				const scrollTop =
					window.pageYOffset || document.documentElement.scrollTop
				const offsetTop = rect.top + scrollTop
				const centerOffset = window.innerHeight / 2 - rect.height / 2
				window.scrollTo({
					top: offsetTop - centerOffset,
					behavior: 'smooth',
				})
				const select = formSection.querySelector('select[name="direction"]')
				if (select) select.value = course.title
			}
		}, 300)
	}

	return (
		<div
			className={`${styles.modalOverlay} ${closing ? styles.closing : ''}`}
			onClick={handleClose}
		>
			<div
				className={`${styles.modalCourse} ${closing ? styles.closing : ''}`}
				onClick={(e) => e.stopPropagation()}
			>
				<button className={styles.modalClose} onClick={handleClose}>
					×
				</button>
				<div className={styles.modalHeader}>
					<img src={course.image} alt={course.title} />
					<div>
						<h2>{course.title}</h2>
						<p className={styles.modalAge}>Возраст: {course.age}</p>
					</div>
				</div>
				<div className={styles.modalBody}>
					<h3>О курсе</h3>
					<p>{course.details.about}</p>
					<h3>Что получит ребёнок</h3>
					<ul>
						{course.details.benefits.map((b, i) => (
							<li key={i}>✅ {b}</li>
						))}
					</ul>
					<h3>Стоимость</h3>
					<ul>
						{course.details.pricing.map((p, i) => (
							<li key={i}>💰 {p}</li>
						))}
					</ul>
				</div>
				<div className={styles.modalFooter}>
					<button className={styles.modalCta} onClick={handleRegister}>
						Оставить заявку
					</button>
				</div>
			</div>
		</div>
	)
}
